import { useEffect, useState } from "react";

/**
 * Хук для анимированного монтирования компонентов.
 *
 * @param {boolean} isVisible - Нужно ли показать компонент (например, true при открытии меню)
 * @param {number} [delay=300] - Длительность анимации в миллисекундах
 * @returns {[boolean, boolean]}
 * [shouldRender, isActive]:
 * - shouldRender — нужно ли рендерить компонент в DOM
 * - isActive — применять ли CSS-класс анимации (например, `opened`)
 */

export function useAnimatedMount(isVisible: boolean, delay = 300) {
    const [shouldRender, setShouldRender] = useState(false);
    const [isActive, setIsActive] = useState(false);

    useEffect(() => {
        if (isVisible) {
            setShouldRender(true);
            requestAnimationFrame(() => setIsActive(true));
        } else {
            setIsActive(false);
            const timeout = setTimeout(() => setShouldRender(false), delay);
            return () => clearTimeout(timeout);
        }
    }, [isVisible, delay]);

    return [shouldRender, isActive];
}
